import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
// constants
import { Forms } from 'constants/index'
// view components
import Tree from 'components/Tree'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import {
  Header,
  Paper
} from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/DetailsForm/components/view'
import { AddButton } from 'components/Modals/PropertyDetailsModal/components/Form/view'
// themes
import { CloseIcon } from 'components/UI/Icons'
import ScaleTreeTheme from './components/ScaleTreeTheme'
// utils
import isNull from 'lodash/fp/isNull'

// constants
export const reactVirtualizedClassName = 'scale-form-virtualized-class'

const BUTTON_STYLE = {
  margin: '0 0 8px 8px'
}

const GRID_STYLE = {
  padding: '0 10px'
}

const TREE_STYLE = {
  paddingTop: '12px',
  outline: 'none'
}

const TREE_WRAPPER_STYLE = {
  minHeight: 220,
  width: '100%'
}

const KPIScaleForm = ({ handleAddOption, handleSubmit, handleSync, hideModal, isLoading, treeSource }) => {
  return (
    <Paper component={'form'} onSubmit={handleSubmit} width={'xs'}>
      <Grid container>
        <Header>
          <span>Scale Options</span>
          <CloseIcon right={0} onClick={hideModal} />
        </Header>

        <Grid container style={TREE_WRAPPER_STYLE}>
          <Tree
            canDrop={({ nextParent }) => isNull(nextParent)}
            canNodeHaveChildren={() => false}
            innerStyle={TREE_STYLE}
            rowHeight={68}
            source={treeSource}
            synchronizeTreeFunc={handleSync}
            theme={ScaleTreeTheme}
            reactVirtualizedListProps={{
              className: reactVirtualizedClassName
            }}
          />
        </Grid>
      </Grid>
      <AddButton style={BUTTON_STYLE} onClick={handleAddOption}>
        + add option
      </AddButton>
      <Grid container style={GRID_STYLE}>
        <Grid container spacing={2}>
          <Grid>
            <Button isLoading={isLoading} layout={BUTTON_LAYOUTS.PURPLE} shadowLess type={'submit'}>
              Save
            </Button>
          </Grid>
          <Grid>
            <Button layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal} shadowLess type={'button'}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default reduxForm({ form: Forms.KPI_SCALE_FORM, enableReinitialize: true })(KPIScaleForm)
